<template>
  <div class="video-list">
    <div
      v-for="(video, index) in videos"
      :key="index"
      class="video-button tilillium text-center"
      :class="{selected: video.orderNumber === current}"
      :id="`button-${index + 1}`"
      @click="playVideo(video)"
      @mouseover="markVideo(video.orderNumber)"
      @mouseleave="markVideo(null)"
      style="cursor: pointer;"
    >
      <img
        :src="video.icon"
        :alt="`Vorschaubild zum Video ${video.titel}`"
        class="video-icon"
        crossOrigin="anonymous"
      />
      <h4>{{ video.titel }}</h4>
    </div>
  </div>
</template>

<script>
import { mapGetters, mapActions } from 'vuex'

export default {
  name: 'video-list',
  props: {
    current: String
  },
  data () {
    return {
        active: true
    }
  },
  methods: {
    ...mapActions({
      setMarkedVideo: 'setMarkedVideo'
    }),
    playVideo(video) {
      if(this.$route.name === 'apparate') {
        this.$store.dispatch('selectVideo', video)
      } else {
        this.$router.push(`/video/${video.orderNumber}`)
      }
    },
    markVideo(nr) {
      this.setMarkedVideo(nr)
    },
    markVideoButton() {
      const videoId = this.selected ? `#button-${this.selected.orderNumber}` : null
      document.querySelectorAll('.video-button').forEach(b => {
        b.classList.remove('selected')
      })
      const selectedButton = document.querySelector(videoId)
      if (selectedButton) selectedButton.classList.add('selected')
    }
  },
  computed: {
      ...mapGetters({
          selected: 'getSelectedVideo',
          videos: 'getVideosData'
      })
  },
  watch: {
    selected: function () {
      this.markVideoButton()
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">
  @import '@/scss/custom.scss';
  .video-list {
    position: absolute;
    top: 6rem;
    right: 0rem;
    max-width: 8rem;
    min-height: calc(100vh - 6rem);
    background-color: $sand-dark-65;
  }
  .video-button {
    border-bottom: 1px solid $grey-light-50;
    &:hover,
    &.selected {
      background-color: $red-dark;
      color: $sand-light;
    }
  }
  .video-icon {
    display: block;
    max-width: 100%;
    padding: 1.2rem 1rem 0 1rem;
  }
  h4 {
    font-size: .8rem;
    margin-bottom: 0;
    padding: .2rem 0 1rem 0;
  }
</style>
